<template>
  <div>
    <validation-observer ref="channelScheduleForm">
      <b-form
        @submit.prevent=""
        @reset.prevent="resetForm"
      >
        <validation-provider
          #default="validationContext"
          name="Filename"
          vid="filename"
          rules="required"
        >
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Filename <span class="text-danger">*</span></label>
            </template>
            <b-form-input
              v-model="frmData.filename"
              type="text"
              trim
              :state="getValidationState(validationContext)"
              placeholder="Tên file..."
            />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider
          #default="validationContext"
          vid="channel_id"
          name="Kênh liên kết"
          rules="required"
        >
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Kênh liên kết <span class="text-danger">*</span></label>
            </template>
            <v-select
              v-model="frmData.channel_id"
              :options="dataChannel"
              label="name"
              :reduce="(val) => val.id"
              placeholder="--Chọn--"
              :state="getValidationState(validationContext)"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <b-form-group class="mb-0">
          <template #label>
            <label class="d-block font-weight-bolder pb-0">Khung giờ <span
                class="badge badge-success ml-2 add"
                @click="addRow()"
              >
                <feather-icon icon="PlusCircleIcon" />
                <span>Thêm</span>
              </span>
            </label>
          </template>
          <ul class="frame">
            <li
              v-for="(item, index) in frmData.content"
              :key="index"
              class="mb-1"
            >
              <div class="d-flex">
                <span class="mr-1">
                  <flat-pickr
                    v-model="item.start_time"
                    class="form-control"
                    :config="config_date"
                    placeholder="Từ giờ"
                  />
                </span>
                <span class="mr-1">
                  <flat-pickr
                    v-model="item.end_time"
                    class="form-control"
                    :config="config_date"
                    placeholder="Đến giờ"
                  />
                </span>
                <span class="align-items-center">
                  <span
                    v-if="index > 0"
                    class="badge badge-danger"
                    @click="removeRow(index)"
                  ><feather-icon icon="Trash2Icon" /></span>
                </span>
              </div>
              <div
                v-if="item.message"
                class="invalid-feedback d-block"
              >{{ item.message }}</div>
            </li>
          </ul>
        </b-form-group>
        <b-form-checkbox
          v-model="frmData.status"
          value="1"
          class="custom-control-primary"
        > Kích hoạt </b-form-checkbox>
        <div class="d-flex mt-1">
          <b-button
            variant="danger"
            type="submit"
            @click.prevent="validationForm"
          > {{ $t('Save') }} </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import {
  required, email, alphaNum, min, max,
} from '@validations'
import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox, BFormCheckboxGroup, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { showToast, useRouter } from '@core/utils/utils';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';

export default {

  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormCheckboxGroup,
    vSelect,
    BListGroup,
    BListGroupItem,
    flatPickr,
  },
  props: {
    dataEdit: {
      type: Object,
      default: null,
    },
    dataChannel: {
      type: Array,
      default: null,
    },

  },
  setup(props, context) {
    const { route, router } = useRouter();
    const blankData = {
      filename: '',
      channel_id: '',
      content: [
        { start_time: '', end_time: '', message: '' },
      ],
    }

    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    if (Object.keys(props.dataEdit).length > 0) {
      frmData.value = props.dataEdit
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)

    const config_date = ref({
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
      time_24hr: true,
    });

    return {
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
      config_date,
    }
  },
  methods: {
    addRow() {
      const item = {
        start_time: '',
        end_time: '',
        message: '',
      }
      this.frmData.content.push(item)
    },
    removeRow(index) {
      this.frmData.content.splice(index, 1)
    },
    onSubmit() {
      if (this.frmData.id) {
        store.dispatch('channel/update', { data: this.frmData, id: this.frmData.id, card_type: 'channel_schedule' })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData()
            } else if (result.errors.length > 0) {
              this.$refs.channelScheduleForm.setErrors(result.errors);
            } else {
              showToast(result.message);
            }
          })
      } else {
        store.dispatch('channel/create', { card_type: 'channel_schedule', params: this.frmData })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData()
            } else if (result.errors.length > 0) {
              this.$refs.channelScheduleForm.setErrors(result.errors);
            } else {
              showToast(result.message);
            }
          })
      }
    },
    valid() {
      let result = true;

      this.frmData.content.forEach((item, index) => {
        const itemPrev = (index > 0) ? this.frmData.content[index - 1] : {};
        if (!item.start_time || !item.end_time) {
          item.message = 'Từ giờ yêu cầu bắt buộc';
          result = false;
        } else if (item.start_time >= item.end_time) {
          item.message = 'Thời gian kết thúc phải lớn hơn thời gian bắt đầu';
          result = false;
        } else if (itemPrev && itemPrev.end_time > item.start_time) {
          item.message = 'Khung giờ sau phải lớn hơn khung giờ trước';
          result = false;
        } else {
          item.message = '';
        }
      })
      return result;
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.channelScheduleForm.validate().then(success => {
        if (success) {
          if (this.valid()) {
            this.onSubmit();
          }
        }
      })
    },
  },
}
</script>
<style lang="scss">
.col-form-label {
  font-size: 1.1rem;
  font-weight: bold
}

.custom-control-label {
  cursor: pointer;
}

.custom-control.custom-checkbox {
  padding-bottom: 0.5rem;
}

.add {
  cursor: pointer;
}

.frame {
  padding: 0;
  margin: 0;
  list-style: none;

  li {
    display: flex;
    flex-direction: column;

    .badge {
      cursor: pointer;
      margin-top: 7px
    }
  }
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
